// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EJYGs{margin-top:16px;width:100%}
.Z8oDR{padding:0 4px 8px 0;margin-bottom:16px;border-bottom:1px solid #e2e8f0}
.rEpSP{font-family:"Inter",sans-serif;font-weight:700;font-size:20px;color:#0f172a;margin-bottom:0;letter-spacing:-0.02em;line-height:1.4}
.MJ7T_{font-family:"Inter",sans-serif;font-weight:600;font-size:15px;color:#64748b;text-transform:uppercase;letter-spacing:.04em;margin:0 0 12px;line-height:1.3}
.wvRdF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:0}
.miTZZ{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;min-height:44px;padding:8px 0;border-bottom:1px solid #f1f5f9}
.miTZZ:last-child{border-bottom:none}
.BOgqd{font-family:"Inter",sans-serif;font-size:15px;font-weight:500;color:#334155;line-height:1.35;-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;min-width:0}
.HUEFy{margin:0 !important;margin-right:0 !important;-ms-flex-negative:0;flex-shrink:0}
._EK_2{margin-left:6px;cursor:help;color:#64748b}
.V7FEi{-ms-flex-negative:0;flex-shrink:0;min-width:140px}
.y8lJk{width:96px;-ms-flex-negative:0;flex-shrink:0}
.y8lJk .MuiInputBase-root{font-size:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EJYGs`,
	"header": `Z8oDR`,
	"title": `rEpSP`,
	"groupTitle": `MJ7T_`,
	"settingsList": `wvRdF`,
	"settingRow": `miTZZ`,
	"settingLabel": `BOgqd`,
	"switchControl": `HUEFy`,
	"settingInfo": `_EK_2`,
	"segmentedControl": `V7FEi`,
	"numberInput": `y8lJk`
};
module.exports = ___CSS_LOADER_EXPORT___;
